/**
 * @autogenerated
 *
 * WARNING: This file is automatically generated based on Contentful schema.
 * DO NOT modify this file manually - your changes will be overwritten.
 *
 * To regenerate this file, run: `yarn contentful generate`.
 * To customize the generated code:
 *   - Modify the schema in Contentful and regenerate.
 *   - Override this module in higher-level packages.
 */

import gql from 'graphql-tag';

import {BaseReviewsFragment} from '@amblique/contentful/app/contentful/fragments/reviews/base-reviews.fragment';
import {BaseReviewItemFragment} from '@amblique/contentful/app/contentful/fragments/review-item/base-review-item.fragment';

export const ReviewsFragment = gql`
  ${BaseReviewItemFragment}
  ${BaseReviewsFragment}

  fragment ReviewsFragment on Reviews {
    ...BaseReviewsFragment

    reviewsCollection {
      items {
        __typename
        ... on ReviewItem {
          ...BaseReviewItemFragment
        }
      }
    }
    reviewsCursorCollection {
      items {
        __typename
        ... on ReviewItem {
          ...BaseReviewItemFragment
        }
      }
    }
  }
`;
